import { manageSubscriptionsStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: ISA REFACTOR
merge(manageSubscriptionsStyles, {
    manageSubscriptionsTitle: {
        variant: "h4",
        as: "h2",
        css: css`
            margin-top: 30px !important;
            display: block !important;
        `,
    },
    manageSubscriptionsCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
    manageSubscriptionsCheckboxGroup: {},
});
